import { ModuleName, DepartmentType } from 'src/app/shared/enums/enums';
import { CrewManagementType } from 'src/app/department/enums/crew-management-types.enum';
import {
  DueListRoutes,
  RoutesEnum,
  UserCertificateRoutes,
  AdminRoutesEnum,
  AdminDepartmentRoutes,
  AdminAlertRoutes,
  AdminUsersRoutes,
  AdminCrewManagementRoutes,
  AdminCompetenceRoutes,
  AdminCertificateRoutes,
  AdminDocumentsRoutes,
  AdminNonConformanceRoutes,
  AdminMaintenanceRoutes,
  AdminStorageRoutes,
  AdminMedicineRoutes,
  UserCrewManagementRoutes,
  AdminOrderRoutes,
  UserDocumentsRoutes,
  UserNonConformancesRoutes,
  AdminRiskAssessmentRoutes,
  AdminWorkAndRestRoutes,
  UserUsersAndPaxRoutes,
  UserWorkAndRestRoutes,
} from '../../enums/routes.enum';
import { Privileges } from '../../privileges/privileges';
import { ModuleNumbers } from '../../enums/module-numbers.enum';

export const ADMIN_USERS_SUBMODULES = [
  {
    name: 'users',
    route: AdminUsersRoutes.Users,
    module: ModuleName.USER,
    privileges: [Privileges.UserRead],
    children: [],
  },
  {
    name: 'pax',
    route: AdminUsersRoutes.Paxes,
    module: ModuleName.USER,
    privileges: [Privileges.PaxRead],
    children: [],
  },
];

export const USER_USERS_SUBMODULES = [
  {
    name: 'users',
    route: UserUsersAndPaxRoutes.Users,
    module: ModuleName.USER,
    privileges: [Privileges.UserRead],
    children: [],
  },
  {
    name: 'pax',
    route: UserUsersAndPaxRoutes.Paxes,
    module: ModuleName.USER,
    privileges: [Privileges.PaxRead],
    children: [],
  },
];

// user routes

export const USER_ALERTS_MENU_LIST_ROUTES = {
  name: 'alerts',
  footerModule: false,
  privileges: [],
  children: [
    {
      name: 'dueList',
      route: DueListRoutes.Main,
      icon: 'format_list_bulleted',
      module: ModuleName.DUE_LIST,
      privileges: [],
      children: [],
    },
    // {
    //   name: 'messages',
    //   route: RoutesEnum.Messages,
    //   icon: 'mark_chat_unread',
    //   module: ModuleName.ALERT,
    //   children: [],
    // },
  ],
};

export const USER_CREW_TRIP_BASED_MENU_LIST_ROUTES = {
  name: 'crew',
  footerModule: false,
  privileges: [Privileges.PlannedActivityRead],
  children: [
    {
      name: 'shiftAndManning',
      route: UserCrewManagementRoutes.BasicTrips,
      icon: 'group_add',
      module: ModuleName.CREWMANAGEMENT,
      privileges: [Privileges.PlannedActivityRead],
      children: [],
    },
    {
      name: 'workAndRest',
      route: UserWorkAndRestRoutes.Main,
      icon: 'calendar_month',
      module: ModuleName.WORKANDREST,
      moduleNumber: ModuleNumbers.WorkAndRest,
      privileges: [],
      children: [],
    },
    {
      name: 'usersAndPax',
      route: UserUsersAndPaxRoutes.Users,
      icon: 'groups',
      module: ModuleName.USER,
      privileges: [Privileges.UserRead, Privileges.PaxRead],
      children: USER_USERS_SUBMODULES,
    },
  ],
};

export const USER_CREW_ACTIVITY_BASED_MENU_LIST_ROUTES = {
  name: 'crew',
  footerModule: false,
  privileges: [Privileges.PlannedActivityRead],
  children: [
    {
      name: 'shiftAndManning',
      route: UserCrewManagementRoutes.Main,
      icon: 'group_add',
      module: ModuleName.CREWMANAGEMENT,
      privileges: [Privileges.PlannedActivityRead],
      children: [],
    },
    {
      name: 'workAndRest',
      route: UserWorkAndRestRoutes.Main,
      icon: 'calendar_month',
      module: ModuleName.WORKANDREST,
      moduleNumber: ModuleNumbers.WorkAndRest,
      privileges: [],
      children: [],
    },
    {
      name: 'usersAndPax',
      route: UserUsersAndPaxRoutes.Users,
      module: ModuleName.USER,
      icon: 'groups',
      privileges: [Privileges.UserRead, Privileges.PaxRead],
      children: USER_USERS_SUBMODULES,
    },
  ],
};

export const USER_DOCUMENTS_MENU_LIST_ROUTES = {
  name: 'documentation',
  footerModule: false,
  privileges: [
    Privileges.CertificateRead,
    Privileges.DocumentRead,
    Privileges.NonConformanceRead,
    Privileges.RiskAssessmentRead,
  ],
  children: [
    {
      name: 'certificates',
      route: UserCertificateRoutes.Main,
      icon: 'description',
      module: ModuleName.COMPETENCE,
      privileges: [Privileges.CertificateRead],
      children: [],
    },
    {
      name: 'documents',
      route: UserDocumentsRoutes.Main,
      icon: 'folder_open',
      module: ModuleName.DOCUMENT,
      privileges: [Privileges.DocumentRead],
      children: [],
    },
    {
      name: 'riskAssessment',
      route: RoutesEnum.RiskAssessments,
      icon: 'balance',
      module: ModuleName.RISKASSESSMENT,
      privileges: [Privileges.RiskAssessmentRead],
      children: [],
    },
    // {
    //   name: 'audits',
    //   route: RoutesEnum.Audits,
    //   icon: 'plagiarism',
    //   module: ModuleName.COMPETENCE,
    //   children: [],
    // },
    {
      name: 'nonConformances',
      route: UserNonConformancesRoutes.Open,
      icon: 'remove_moderator',
      module: ModuleName.NONCONFORMANCE,
      privileges: [Privileges.NonConformanceRead],
      children: [],
    },
  ],
};

export const USER_DOCUMENTS_MENU_LIST_ROUTES_ALL_DEPS = {
  name: 'documentation',
  footerModule: false,
  privileges: [Privileges.NonConformanceRead],
  children: [
    {
      name: 'nonConformances',
      route: UserNonConformancesRoutes.Open,
      icon: 'remove_moderator',
      module: ModuleName.NONCONFORMANCE,
      privileges: [Privileges.NonConformanceRead],
      children: [],
    },
  ],
};

export const USER_DEPARTMENTS_MENU_LIST_ROUTES = {
  name: 'department',
  footerModule: false,
  privileges: [
    Privileges.RuntimeRead,
    Privileges.MaintenanceJobRead,
    Privileges.StorageProductRead,
    Privileges.MedicineRead,
    Privileges.DrillRead,
    Privileges.TaskRead,
    Privileges.OrderRead,
  ],
  children: [
    {
      name: 'runTime',
      route: RoutesEnum.RunTime,
      icon: 'update',
      module: ModuleName.COMPETENCE,
      privileges: [Privileges.RuntimeRead],
      children: [],
    },
    {
      name: 'maintenance',
      route: RoutesEnum.Maintenance,
      icon: 'build',
      module: ModuleName.MAINTENANCE,
      privileges: [Privileges.MaintenanceJobRead, Privileges.RuntimeRead],
      checkAllPrivileges: true,
      children: [],
    },
    // {
    //   name: 'emissions',
    //   route: RoutesEnum.Emissions,
    //   icon: 'air',
    //   module: ModuleName.COMPETENCE,
    //   children: [],
    // },
    {
      name: 'storage',
      route: RoutesEnum.Storage,
      icon: 'view_in_ar',
      module: ModuleName.STORAGE,
      privileges: [Privileges.StorageProductRead],
      children: [],
    },
    {
      name: 'medicines',
      route: RoutesEnum.Medicines,
      icon: 'local_hospital',
      module: ModuleName.MEDICINE,
      privileges: [Privileges.MedicineRead],
      children: [],
    },
    {
      name: 'drills',
      route: RoutesEnum.Drills,
      icon: 'campaign',
      module: ModuleName.DRILL,
      privileges: [Privileges.DrillRead],
      children: [],
    },
    {
      name: 'tasks',
      route: RoutesEnum.Checklists,
      icon: 'checklist_rtl',
      module: ModuleName.COMPETENCE,
      privileges: [Privileges.TaskRead],
      children: [],
    },
    {
      name: 'purchase',
      route: RoutesEnum.Purchase,
      icon: 'shopping_cart',
      module: ModuleName.ORDER,
      privileges: [Privileges.OrderRead],
      children: [],
    },
  ],
};

export const USER_DEPARTMENT_MENU_LIST_ROUTES_ALL_DEPS = {
  name: 'department',
  footerModule: false,
  privileges: [Privileges.StorageProductRead, Privileges.OrderRead],
  children: [
    {
      name: 'storage',
      route: RoutesEnum.Storage,
      icon: 'view_in_ar',
      module: ModuleName.STORAGE,
      privileges: [Privileges.StorageProductRead],
      children: [],
    },
    {
      name: 'purchase',
      route: RoutesEnum.Purchase,
      icon: 'shopping_cart',
      module: ModuleName.ORDER,
      privileges: [Privileges.OrderRead],
      children: [],
    },
  ],
};

export const USER_OTHER_MENU_LIST_ROUTES = {
  name: 'other',
  footerModule: true,
  privileges: [
    Privileges.DepartmentRead,
    Privileges.DepartmentGroupRead,
    Privileges.AlertRead,
    Privileges.QuantityTypeRead,
    Privileges.UserRead,
    Privileges.PaxRead,
    Privileges.ActivityRead,
    Privileges.ShiftRead,
    Privileges.CompetenceRead,
    Privileges.CompetenceGroupRead,
    Privileges.PositionRead,
    Privileges.PositionGroupRead,
    Privileges.UserCompetenceMatrixAdmin,
    Privileges.MenuUpdate,
    Privileges.NonConformanceTypeRead,
    Privileges.SeverityRead,
    Privileges.NonConformanceReportSettingsUpdate,
    Privileges.OrderTypeRead,
    Privileges.SupplierRead,
    Privileges.PurchaserRead,
    Privileges.AccountGroupRead,
    Privileges.AccountRead,
    Privileges.OrdersSettingsRead,
    Privileges.DeliveryConditionRead,
    Privileges.MaintenanceJobTypeRead,
    Privileges.ComponentRead,
    Privileges.StorageProductCategoryRead,
    Privileges.MedicineCategoryRead,
    Privileges.FormLibraryRead,
  ],
  children: [
    // {
    //   name: 'help',
    //   route: SupportRoutes.Help,
    //   icon: 'help',
    //   module: ModuleName.COMPETENCE,
    //   children: [],
    // },
    {
      name: 'adminSettings',
      route: AdminRoutesEnum.Admin,
      icon: 'settings',
      module: ModuleName.COMPETENCE,
      privileges: [
        Privileges.DepartmentRead,
        Privileges.DepartmentGroupRead,
        Privileges.AlertRead,
        Privileges.QuantityTypeRead,
        Privileges.UserRead,
        Privileges.PaxRead,
        Privileges.ActivityRead,
        Privileges.ShiftRead,
        Privileges.CompetenceRead,
        Privileges.CompetenceGroupRead,
        Privileges.PositionRead,
        Privileges.PositionGroupRead,
        Privileges.UserCompetenceMatrixAdmin,
        Privileges.MenuUpdate,
        Privileges.NonConformanceTypeRead,
        Privileges.NonConformanceReportSettingsUpdate,
        Privileges.SeverityRead,
        Privileges.OrderTypeRead,
        Privileges.SupplierRead,
        Privileges.PurchaserRead,
        Privileges.AccountGroupRead,
        Privileges.AccountRead,
        Privileges.OrdersSettingsRead,
        Privileges.DeliveryConditionRead,
        Privileges.MaintenanceJobTypeRead,
        Privileges.ComponentRead,
        Privileges.ComponentGroupRead,
        Privileges.StorageProductCategoryRead,
        Privileges.MedicineCategoryRead,
        Privileges.FormLibraryRead,
        Privileges.PrivilegeTemplateRead,
        Privileges.DocumentRead,
        Privileges.DrillRead,
        Privileges.TaskRead,
        Privileges.CertificateRead,
        Privileges.RiskAssessmentRead,
      ],
      children: [],
    },
  ],
};

function getRoutesBasedOnDepartmentType(departmentType: number, routes: any): any {
  if (departmentType === DepartmentType.Vessel.id) {
    return routes;
  }
  const routesCopy = { ...routes };
  const filteredChildren = routesCopy.children.filter((child: any) => child.name !== 'workAndRest');
  routesCopy.children = filteredChildren;
  return routesCopy;
}

export function getUserMenuListRoutes(config: {
  crewManagementType: number;
  departmentType: number;
}): any[] {
  return [
    USER_ALERTS_MENU_LIST_ROUTES,
    config.crewManagementType === CrewManagementType.TripBased
      ? getRoutesBasedOnDepartmentType(config.departmentType, USER_CREW_TRIP_BASED_MENU_LIST_ROUTES)
      : getRoutesBasedOnDepartmentType(
          config.departmentType,
          USER_CREW_ACTIVITY_BASED_MENU_LIST_ROUTES
        ),
    USER_DOCUMENTS_MENU_LIST_ROUTES,
    USER_DEPARTMENTS_MENU_LIST_ROUTES,
    USER_OTHER_MENU_LIST_ROUTES,
  ];
}

export function getUserMenuListRoutesForAllDeps(): any[] {
  return [
    USER_ALERTS_MENU_LIST_ROUTES,
    USER_DOCUMENTS_MENU_LIST_ROUTES_ALL_DEPS,
    USER_DEPARTMENT_MENU_LIST_ROUTES_ALL_DEPS,
  ];
}

// admin routes
export const ADMIN_DEPARTMENT_SUBMODULES = [
  {
    name: 'department',
    route: AdminDepartmentRoutes.Main,
    module: ModuleName.DEPARTMENT,
    privileges: [Privileges.DepartmentRead],
    children: [],
  },
  {
    name: 'groups',
    route: AdminDepartmentRoutes.Groups,
    module: ModuleName.DEPARTMENT,
    privileges: [Privileges.DepartmentGroupRead],
    children: [],
  },
];
export const ADMIN_COMPETENCE_SUBMODULES = [
  {
    name: 'competence',
    route: AdminCompetenceRoutes.Main,
    module: ModuleName.COMPETENCE,
    privileges: [Privileges.CompetenceRead],
    children: [],
  },
  {
    name: 'competenceGroups',
    route: AdminCompetenceRoutes.Groups,
    module: ModuleName.COMPETENCE,
    privileges: [Privileges.CompetenceGroupRead],
    children: [],
  },
  {
    name: 'jobPositions',
    route: AdminCompetenceRoutes.JobPositions,
    module: ModuleName.COMPETENCE,
    privileges: [Privileges.PositionRead],
    children: [],
  },
  {
    name: 'jobPositionGroups',
    route: AdminCompetenceRoutes.JobPositionGroups,
    module: ModuleName.COMPETENCE,
    privileges: [Privileges.PositionGroupRead],
    children: [],
  },
  {
    name: 'roles',
    route: AdminCompetenceRoutes.Roles,
    module: ModuleName.COMPETENCE,
    privileges: [Privileges.RolesRead],
    children: [],
  },
  {
    name: 'privilegeTemplates',
    route: AdminCompetenceRoutes.PrivilegeTemplates,
    module: ModuleName.COMPETENCE,
    privileges: [Privileges.PrivilegeTemplateRead],
    children: [],
  },
  {
    name: 'competenceMatrix',
    route: AdminCompetenceRoutes.Matrix,
    module: ModuleName.COMPETENCE,
    privileges: [Privileges.UserCompetenceMatrixAdmin],
    children: [],
  },
];
export const ADMIN_MAINTENANCE_SUBMODULES = [
  {
    name: 'jobTypes',
    route: AdminMaintenanceRoutes.JobTypes,
    module: ModuleName.MAINTENANCE,
    privileges: [Privileges.MaintenanceJobTypeRead],
    children: [],
  },
  {
    name: 'jobAreas',
    route: AdminMaintenanceRoutes.JobAreas,
    module: ModuleName.MAINTENANCE,
    privileges: [Privileges.MaintenanceJobAreaRead],
    children: [],
  },
  {
    name: 'components',
    route: AdminMaintenanceRoutes.Components,
    module: ModuleName.MAINTENANCE,
    privileges: [Privileges.ComponentRead, Privileges.ComponentGroupRead],
    children: [],
  },
  {
    name: 'standardJobTemplates',
    route: AdminMaintenanceRoutes.StandardJobTemplatesRoot,
    module: ModuleName.MAINTENANCE,
    privileges: [Privileges.StandardJobTemplateRead],
    children: [],
  },
  {
    name: 'standardJobStructure',
    route: AdminMaintenanceRoutes.StandardJobTemplatesStructure,
    module: ModuleName.MAINTENANCE,
    privileges: [Privileges.StandardJobTemplateRead],
    children: [],
  },
  {
    name: 'maintenanceSettings',
    route: AdminMaintenanceRoutes.MaintenanceSettings,
    module: ModuleName.MAINTENANCE,
    privileges: [Privileges.MaintenanceSettingsUpdate],
    children: [],
  },
];
export const ADMIN_NONCONFORMANCE_SUBMODULES = [
  {
    name: 'nonConformanceTypes',
    route: AdminNonConformanceRoutes.Types,
    module: ModuleName.NONCONFORMANCE,
    privileges: [Privileges.NonConformanceTypeRead],
    children: [],
  },
  {
    name: 'severities',
    route: AdminNonConformanceRoutes.SeverityTypes,
    module: ModuleName.NONCONFORMANCE,
    privileges: [Privileges.SeverityRead],
    children: [],
  },
  {
    name: 'seaState',
    route: AdminNonConformanceRoutes.SeaState,
    module: ModuleName.NONCONFORMANCE,
    privileges: [Privileges.NonConformanceSeaStateRead],
    children: [],
  },
  {
    name: 'weatherInformation',
    route: AdminNonConformanceRoutes.WeatherInformation,
    module: ModuleName.NONCONFORMANCE,
    privileges: [Privileges.NonConformanceWeatherInformationRead],
    children: [],
  },
  {
    name: 'locationOnDepartment',
    route: AdminNonConformanceRoutes.LocationOnDepartment,
    module: ModuleName.NONCONFORMANCE,
    privileges: [Privileges.NonConformanceLocationRead],
    children: [],
  },
  {
    name: 'cause',
    route: AdminNonConformanceRoutes.Cause,
    module: ModuleName.NONCONFORMANCE,
    privileges: [Privileges.NonConformanceCauseRead],
    children: [],
  },
  {
    name: 'customProperties',
    route: AdminNonConformanceRoutes.CustomProperties,
    module: ModuleName.NONCONFORMANCE,
    privileges: [Privileges.CustomPropertyDefinitionRead],
    children: [],
  },
  {
    name: 'reportSettings',
    route: AdminNonConformanceRoutes.ReportSettings,
    module: ModuleName.NONCONFORMANCE,
    privileges: [Privileges.NonConformanceReportSettingsUpdate],
    children: [],
  },
];
export const ADMIN_CREW_MANAGEMENT_SUBMODULES = [
  {
    name: 'activities',
    route: AdminCrewManagementRoutes.Activities,
    module: ModuleName.CREWMANAGEMENT,
    privileges: [Privileges.ActivityRead],
    children: [],
  },
  {
    name: 'shifts',
    route: AdminCrewManagementRoutes.Shifts,
    module: ModuleName.CREWMANAGEMENT,
    privileges: [Privileges.ShiftRead],
    children: [],
  },
];
export const ADMIN_DOCUMENTS_SUBMODULES = [
  {
    name: 'structures',
    route: AdminDocumentsRoutes.Structure,
    module: ModuleName.DOCUMENT,
    privileges: [Privileges.MenuRead, Privileges.DocumentsAdmin],
    children: [],
  },
  {
    name: 'settings',
    route: AdminDocumentsRoutes.Settings,
    module: ModuleName.DOCUMENT,
    privileges: [
      Privileges.DocumentSettingsRead,
      Privileges.DocumentSettingsUpdate,
      Privileges.DocumentsAdmin,
    ],
    children: [],
  },
];
export const ADMIN_MEDICINE_SUBMODULES = [
  {
    name: 'structure',
    route: AdminMedicineRoutes.Structure,
    module: ModuleName.MEDICINE,
    privileges: [Privileges.MenuRead, Privileges.MedicinesAdmin],
    children: [],
  },
  {
    name: 'medicineCategories',
    route: AdminMedicineRoutes.Categories,
    module: ModuleName.MEDICINE,
    privileges: [Privileges.MedicineCategoryRead],
    children: [],
  },
];
export const ADMIN_STORAGE_SUBMODULES = [
  {
    name: 'structure',
    route: AdminStorageRoutes.Structure,
    module: ModuleName.STORAGE,
    privileges: [Privileges.MenuRead, Privileges.StorageAdmin],
    children: [],
  },
  {
    name: 'storageCategories',
    route: AdminStorageRoutes.Categories,
    module: ModuleName.STORAGE,
    privileges: [Privileges.StorageProductCategoryRead],
    children: [],
  },
  {
    name: 'productTypes',
    route: AdminStorageRoutes.ProductTypes,
    module: ModuleName.STORAGE,
    privileges: [Privileges.ProductTypeRead],
    children: [],
  },
];
export const ADMIN_ORDER_SUBMODULES = [
  {
    name: 'orderTypes',
    route: AdminOrderRoutes.OrderTypes,
    module: ModuleName.ORDER,
    privileges: [Privileges.OrderTypeRead],
    children: [],
  },
  {
    name: 'suppliers',
    route: AdminOrderRoutes.Suppliers,
    module: ModuleName.ORDER,
    privileges: [Privileges.SupplierRead],
    children: [],
  },
  {
    name: 'purchasers',
    route: AdminOrderRoutes.Purchasers,
    module: ModuleName.ORDER,
    privileges: [Privileges.PurchaserRead],
    children: [],
  },
  {
    name: 'accountGroups',
    route: AdminOrderRoutes.AccountGroups,
    module: ModuleName.ORDER,
    privileges: [Privileges.AccountGroupRead],
    children: [],
  },
  {
    name: 'accounts',
    route: AdminOrderRoutes.Accounts,
    module: ModuleName.ORDER,
    privileges: [Privileges.AccountRead],
    children: [],
  },
  {
    name: 'deliveryConditions',
    route: AdminOrderRoutes.DeliveryConditions,
    module: ModuleName.ORDER,
    privileges: [Privileges.DeliveryConditionRead],
    children: [],
  },
  {
    name: 'deliveryAddresses',
    route: AdminOrderRoutes.DeliveryAddresses,
    module: ModuleName.ORDER,
    privileges: [Privileges.DeliveryAddressRead],
    children: [],
  },
  {
    name: 'sfiCodes',
    route: AdminOrderRoutes.SfiCodes,
    module: ModuleName.ORDER,
    privileges: [Privileges.SfiCodeDefinitionRead],
    children: [],
  },
  {
    name: 'settings',
    route: AdminOrderRoutes.Settings,
    module: ModuleName.ORDER,
    privileges: [Privileges.OrdersSettingsRead],
    children: [],
  },
];
export const ADMIN_WORK_AND_REST_SUBMODULES = [
  {
    name: 'workScheduleTemplates',
    route: `${AdminWorkAndRestRoutes.WorkScheduleTemplates}`,
    module: ModuleName.WORKANDREST,
    moduleNumber: ModuleNumbers.WorkAndRest,
    privileges: [Privileges.ScheduleTemplateRead],
    children: [],
  },
  {
    name: 'workPlanTemplates',
    route: `${AdminWorkAndRestRoutes.WorkPlanTemplates}`,
    module: ModuleName.WORKANDREST,
    moduleNumber: ModuleNumbers.WorkAndRest,
    privileges: [Privileges.WorkPlanTemplateRead],
    children: [],
  },
  {
    name: 'overtimeTypes',
    route: `${AdminWorkAndRestRoutes.OvertimeTypes}`,
    module: ModuleName.WORKANDREST,
    moduleNumber: ModuleNumbers.WorkAndRest,
    privileges: [Privileges.OvertimeTypeRead],
    children: [],
  },
];
export const ADMIN_RISK_ASSESSMENT_MODULES = [
  {
    name: 'structure',
    route: AdminRiskAssessmentRoutes.Structure,
    module: ModuleName.RISKASSESSMENT,
    privileges: [Privileges.MenuRead, Privileges.RiskAssessmentsAdmin],
    children: [],
  },
  {
    name: 'hazards',
    route: AdminRiskAssessmentRoutes.Hazards,
    module: ModuleName.RISKASSESSMENT,
    privileges: [Privileges.RiskAssessmentHazardRead],
    children: [],
  },
  {
    name: 'consequences',
    route: AdminRiskAssessmentRoutes.Consequences,
    module: ModuleName.RISKASSESSMENT,
    privileges: [Privileges.RiskAssessmentConsequenceRead],
    children: [],
  },
  {
    name: 'locations',
    route: AdminRiskAssessmentRoutes.Locations,
    module: ModuleName.RISKASSESSMENT,
    privileges: [Privileges.RiskAssessmentLocationRead],
    children: [],
  },
  {
    name: 'mitigatingMeasures',
    route: AdminRiskAssessmentRoutes.MitigatingMeasures,
    module: ModuleName.RISKASSESSMENT,
    privileges: [Privileges.RiskAssessmentMitigatingMeasuresRead],
    children: [],
  },
  {
    name: 'operationTypes',
    route: AdminRiskAssessmentRoutes.OperationTypes,
    module: ModuleName.RISKASSESSMENT,
    privileges: [Privileges.RiskAssessmentOperationTypeRead],
    children: [],
  },
  // {
  //   name: 'settings',
  //   route: AdminRiskAssessmentRoutes.Settings,
  //   module: ModuleName.RISKASSESSMENT,
  //   children: [],
  // },
];
export const ADMIN_CERTIFICATE_SUBMODULES = [
  {
    name: 'structure',
    route: AdminCertificateRoutes.Structure,
    module: ModuleName.CERTIFICATE,
    privileges: [Privileges.MenuRead, Privileges.CertificatesAdmin],
    children: [],
  },
  {
    name: 'certificateTypes',
    route: AdminCertificateRoutes.CertificateTypes,
    module: ModuleName.CERTIFICATE,
    privileges: [Privileges.CertificateTypeRead],
    children: [],
  },
];

export const ADMIN_TENANT_SETTINGS_MENU_LIST_ROUTES = {
  name: 'tenantSettings',
  footerModule: false,
  privileges: [
    Privileges.DepartmentRead,
    Privileges.DepartmentGroupRead,
    Privileges.AlertRead,
    Privileges.QuantityTypeRead,
  ],
  children: [
    {
      name: 'department',
      route: `${AdminDepartmentRoutes.Main}`,
      module: ModuleName.DEPARTMENT,
      privileges: [Privileges.DepartmentRead, Privileges.DepartmentGroupRead],
      children: ADMIN_DEPARTMENT_SUBMODULES,
    },
    {
      name: 'alerts',
      route: `${AdminAlertRoutes.Main}`,
      module: ModuleName.ALERT,
      privileges: [Privileges.AlertRead],
      children: [],
    },
    {
      name: 'quantityTypes',
      route: `${AdminRoutesEnum.Admin}/${AdminRoutesEnum.QuantityTypes}`,
      module: ModuleName.QUANTITYTYPES,
      privileges: [Privileges.QuantityTypeRead],
      children: [],
    },
  ],
};
export const ADMIN_CREW_MANAGEMENT_AND_PAX_MENU_LIST_ROUTES = {
  name: 'crewManagementAndPax',
  footerModule: false,
  privileges: [
    Privileges.UserRead,
    Privileges.PaxRead,
    Privileges.ActivityRead,
    Privileges.ShiftRead,
    Privileges.CompetenceRead,
    Privileges.CompetenceGroupRead,
    Privileges.PositionRead,
    Privileges.PositionGroupRead,
    Privileges.UserCompetenceMatrixAdmin,
  ],
  children: [
    {
      name: 'usersAndPax',
      route: AdminUsersRoutes.Users,
      module: ModuleName.USER,
      privileges: [Privileges.UserRead, Privileges.PaxRead],
      children: ADMIN_USERS_SUBMODULES,
    },
    {
      name: 'crewManagement',
      route: `${AdminCrewManagementRoutes.Activities}`,
      module: ModuleName.CREWMANAGEMENT,
      privileges: [Privileges.ActivityRead, Privileges.ShiftRead],
      children: ADMIN_CREW_MANAGEMENT_SUBMODULES,
    },
    {
      name: 'competence',
      route: `${AdminCompetenceRoutes.Main}`,
      module: ModuleName.COMPETENCE,
      privileges: [
        Privileges.CompetenceRead,
        Privileges.CompetenceGroupRead,
        Privileges.PositionRead,
        Privileges.PositionGroupRead,
        Privileges.UserCompetenceMatrixAdmin,
      ],
      children: ADMIN_COMPETENCE_SUBMODULES,
    },
    {
      name: 'workAndRest',
      route: `${AdminWorkAndRestRoutes.WorkScheduleTemplates}`,
      module: ModuleName.WORKANDREST,
      moduleNumber: ModuleNumbers.WorkAndRest,
      privileges: [
        Privileges.ScheduleTemplateRead,
        Privileges.WorkPlanTemplateRead,
        Privileges.OvertimeTypeRead,
      ],
      children: ADMIN_WORK_AND_REST_SUBMODULES,
    },
    {
      name: 'messages',
      route: AdminUsersRoutes.Messages,
      module: ModuleName.USER,
      privileges: [Privileges.MessagesSend],
      children: [],
    },
  ],
};
export const ADMIN_DOCUMENTATION_AND_REPORTS_MENU_LIST_ROUTES = {
  name: 'documentationAndReports',
  footerModule: false,
  privileges: [
    Privileges.MenuUpdate,
    Privileges.NonConformanceTypeRead,
    Privileges.NonConformanceReportSettingsUpdate,
    Privileges.SeverityRead,
    Privileges.OrderTypeRead,
    Privileges.SupplierRead,
    Privileges.PurchaserRead,
    Privileges.AccountGroupRead,
    Privileges.AccountRead,
    Privileges.OrdersSettingsRead,
    Privileges.DeliveryConditionRead,
    Privileges.CertificateTypeRead,
  ],
  children: [
    // {
    //   name: 'audit',
    //   route: 'admin/audit',
    //   module: ModuleName.NONCONFORMANCE,
    //   children: [],
    // },
    {
      name: 'certificate',
      route: AdminCertificateRoutes.Structure,
      module: ModuleName.CERTIFICATE,
      privileges: [Privileges.MenuUpdate, Privileges.CertificateTypeRead],
      children: ADMIN_CERTIFICATE_SUBMODULES,
    },
    {
      name: 'document',
      route: AdminDocumentsRoutes.Structure,
      module: ModuleName.DOCUMENT,
      privileges: [Privileges.MenuUpdate, Privileges.DocumentsAdmin],
      children: [
        {
          name: 'structures',
          route: AdminDocumentsRoutes.Structure,
          module: ModuleName.DOCUMENT,
          privileges: [Privileges.MenuUpdate, Privileges.DocumentsAdmin],
          children: [],
        },
        {
          name: 'settings',
          route: AdminDocumentsRoutes.Settings,
          module: ModuleName.DOCUMENT,
          privileges: [
            Privileges.DocumentSettingsRead,
            Privileges.DocumentSettingsUpdate,
            Privileges.DocumentsAdmin,
          ],
          children: [],
        },
      ],
    },
    {
      name: 'purchase',
      route: AdminOrderRoutes.OrderTypes,
      module: ModuleName.ORDER,
      privileges: [
        Privileges.OrderTypeRead,
        Privileges.SupplierRead,
        Privileges.PurchaserRead,
        Privileges.AccountGroupRead,
        Privileges.AccountRead,
        Privileges.OrdersSettingsRead,
        Privileges.DeliveryConditionRead,
      ],
      children: ADMIN_ORDER_SUBMODULES,
    },
    {
      name: 'nonConformance',
      route: AdminNonConformanceRoutes.Types,
      module: ModuleName.NONCONFORMANCE,
      privileges: [
        Privileges.NonConformanceTypeRead,
        Privileges.SeverityRead,
        Privileges.NonConformanceReportSettingsUpdate,
      ],
      children: ADMIN_NONCONFORMANCE_SUBMODULES,
    },
    {
      name: 'riskAssessment',
      route: AdminRiskAssessmentRoutes.Structure,
      module: ModuleName.RISKASSESSMENT,
      privileges: [
        Privileges.RiskAssessmentHazardRead,
        Privileges.RiskAssessmentLocationRead,
        Privileges.RiskAssessmentConsequenceRead,
        Privileges.RiskAssessmentMitigatingMeasuresRead,
        Privileges.RiskAssessmentOperationTypeRead,
      ],
      children: ADMIN_RISK_ASSESSMENT_MODULES,
    },
  ],
};
export const ADMIN_MAINTENANCE_AND_STORAGE_MENU_LIST_ROUTES = {
  name: 'maintenanceAndStorage',
  footerModule: false,
  privileges: [
    Privileges.MaintenanceJobTypeRead,
    Privileges.ComponentRead,
    Privileges.ComponentGroupRead,
    Privileges.MenuUpdate,
    Privileges.StorageProductCategoryRead,
    Privileges.MedicineCategoryRead,
  ],
  children: [
    {
      name: 'maintenance',
      route: `${AdminRoutesEnum.Admin}/maintenance`,
      module: ModuleName.MAINTENANCE,
      privileges: [
        Privileges.MaintenanceJobTypeRead,
        Privileges.ComponentRead,
        Privileges.ComponentGroupRead,
      ],
      children: ADMIN_MAINTENANCE_SUBMODULES,
    },
    {
      name: 'storage',
      route: `${AdminRoutesEnum.Admin}/storage`,
      module: ModuleName.STORAGE,
      privileges: [Privileges.MenuUpdate, Privileges.StorageProductCategoryRead],
      children: ADMIN_STORAGE_SUBMODULES,
    },
    {
      name: 'medicine',
      route: `${AdminRoutesEnum.Admin}/medicine`,
      module: ModuleName.MEDICINE,
      privileges: [Privileges.MenuUpdate, Privileges.MedicineCategoryRead],
      children: ADMIN_MEDICINE_SUBMODULES,
    },
  ],
};
export const ADMIN_FORMS_AND_DRILLS_MENU_LIST_ROUTES = {
  name: 'formAndDrills',
  footerModule: false,
  privileges: [Privileges.FormLibraryRead, Privileges.MenuUpdate],
  children: [
    {
      name: 'forms',
      route: `${AdminRoutesEnum.Admin}/${AdminRoutesEnum.Forms}`,
      module: ModuleName.COMPETENCE,
      privileges: [Privileges.FormLibraryRead],
      children: [],
    },
    {
      name: 'drills',
      route: `${AdminRoutesEnum.Admin}/${AdminRoutesEnum.Drills}`,
      module: ModuleName.NONCONFORMANCE,
      privileges: [Privileges.MenuUpdate, Privileges.DrillsAdmin],
      children: [],
    },
    {
      name: 'tasks',
      route: `${AdminRoutesEnum.Admin}/${AdminRoutesEnum.Tasks}`,
      module: ModuleName.NONCONFORMANCE,
      privileges: [Privileges.MenuUpdate, Privileges.TasksAdmin],
      children: [],
    },
  ],
};
export const ADMIN_PRODUCT_OWNER_MENU_LIST_ROUTES = {
  name: 'productOwner',
  footerModule: false,
  privileges: [],
  children: [
    {
      name: 'tenant',
      route: `${AdminRoutesEnum.Admin}/${AdminRoutesEnum.Tenant}`,
      module: ModuleName.TENANT,
      privileges: [],
      children: [],
    },
    {
      name: 'productOwner',
      route: `${AdminRoutesEnum.Admin}/${AdminRoutesEnum.ProductOwner}`,
      module: ModuleName.PRODUCTOWNER,
      privileges: [],
      children: [],
    },
    {
      name: 'users',
      route: `${AdminRoutesEnum.Admin}/${AdminRoutesEnum.ProductOwnerUsers}`,
      module: ModuleName.USER,
      privileges: [],
      children: [],
    },
  ],
};
export const ADMIN_MENU_LIST_ROUTES = [
  ADMIN_TENANT_SETTINGS_MENU_LIST_ROUTES,
  ADMIN_CREW_MANAGEMENT_AND_PAX_MENU_LIST_ROUTES,
  ADMIN_DOCUMENTATION_AND_REPORTS_MENU_LIST_ROUTES,
  ADMIN_MAINTENANCE_AND_STORAGE_MENU_LIST_ROUTES,
  ADMIN_FORMS_AND_DRILLS_MENU_LIST_ROUTES,
  ADMIN_PRODUCT_OWNER_MENU_LIST_ROUTES,
];

export function getAdminRoutesWithChildren(): string[] {
  const routes: string[] = [];
  ADMIN_MENU_LIST_ROUTES.map((r) => r.children)
    .flat()
    .forEach((route) => {
      if (route.children.length) {
        routes.push(route.route, ...route.children.map((r) => r.route));
      }
    });
  return routes;
}
